import { render, staticRenderFns } from "./ExpedientePersonalSection.vue?vue&type=template&id=80c9e0a8&scoped=true"
import script from "./ExpedientePersonalSection.vue?vue&type=script&lang=js"
export * from "./ExpedientePersonalSection.vue?vue&type=script&lang=js"
import style0 from "./ExpedientePersonalSection.vue?vue&type=style&index=0&id=80c9e0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c9e0a8",
  null
  
)

export default component.exports